// @ts-nocheck
import React, { useEffect, useState } from 'react';
import {Link} from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import ls from 'localstorage-slim';
import { useTheme } from '@mui/material/styles';

// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

// ----------------------------------------------------------------------
const ProjectPage = () => {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // ----------------------------------------------------------------------
    const [open, setOpen] = useState(null);

    const [page, setPage] = useState(0);

    const [order, setOrder] = useState('asc');

    const [selected, setSelected] = useState([]);

    const [orderBy, setOrderBy] = useState('name');

    const [filterName, setFilterName] = useState('');

    const [rowsPerPage, setRowsPerPage] = useState(5);

    var project_index_mapping = null
    var project_source_mapping = null
    const[projectSourceMapping, setProjectSourceMapping] = useState(null)
    var projlist = []
    var [project, setProject] = useState('');
    var [projectIndex, setProjectIndex] = useState('');
    var projectmenulist = [{label:"None", value:"None"}]
    var projectSourceList = [{label:"None", value:"None"}]
    const [username, setUsername] = useState("")
    var [projectsDetails, setProjectsDetails] = React.useState([]);
    var [projectSourceDetails, setProjectSourceDetails] = React.useState([]);
    const [projectInfo, setProjectInfo] = useState(null);
    useEffect(() => { 
      const load_project_info = async() => {
        const user_data = ls.get('token-gpt-app');
        
        
        //@ts-ignore
            fetch((process.env.REACT_APP_PROJECT_INFO_URL || 
              // "http://localhost:7071/api/project_info"), {
              ''), {
                method: 'POST',
                body: JSON.stringify({ "fetch_all": "true", "user": user_data.email.split('@')[0]})
            })
                .then((response) => {
                    return response.json();
                })
                .then(data => {
                    // Use the data from the response
                    // console.log(data);
                    //@ts-ignore
                    project_index_mapping = data

                    setProjectInfo(project_index_mapping)
                    // console.log('project index mapping : ', project_index_mapping)
                    projlist = Object.keys(project_index_mapping)
                    // console.log('KEYS in project index mapping : ', projlist)
                    // console.log('VALUES in project index mapping : ', Object.values(project_index_mapping))
                })
                .catch((err) => {
                    console.log(err.message);
                });
            }
        // }
        if(projectInfo == null){
          load_project_info()
        }
      // const load_info = async() => { 
      //   await get_chat_info(1, "knowledge_ai", "tluser")
      // }
      // load_info()
    }, [isLoading]);
    const TABLE_HEAD = [
      { id: 'ProjectName', label: 'Project Name', alignRight: false },
      { id: 'IndexName', label: 'Index Name', alignRight: false },
      { id: 'Username', label: 'Username', alignRight: false },
      { id: 'Budget', label: 'Budget', alignRight: false },
      { id: 'status', label: 'Status', alignRight: false },
      {id:''}
    ];
    const handleOpenMenu = (event:any) => {
      setOpen(event.currentTarget);
    };

    const handleCloseMenu = () => {
      setOpen(null);
    };

    const handleRequestSort = (event:any, property:any) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };

    const handleSelectAllClick = (event:any) => {
      if (event.target.checked) {
        const newSelecteds: any = projectInfo.map((n) => n.ProjectName);
        setSelected(newSelecteds);
        return;
      }
      setSelected([]);
    };

    const descendingComparator = (a:any, b:any, orderBy:any) => {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
      return 0;
    }
  
    const getComparator = (order:any, orderBy:any) =>{
      return order === 'desc'
        ? (a:any, b:any) => descendingComparator(a, b, orderBy)
        : (a:any, b:any) => -descendingComparator(a, b, orderBy);
    }
  
    const applySortFilter = (array:any, comparator:any, query:any) =>{
      if(array == null) return ([])
      const stabilizedThis = array.map((el:any, index:any) => [el, index]);
      stabilizedThis.sort((a:any, b:any) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
      if (query) {
        return filter(array, (_user) => _user.ProjectName.toLowerCase().indexOf(query.toLowerCase()) !== -1);
      }
      return stabilizedThis.map((el:any) => el[0]);
    }

    const handleClick = (event:any, name:any) => {
      const selectedIndex = selected.indexOf(name);
      let newSelected:any = [];
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, name);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
      }
      setSelected(newSelected);
    };

    const handleChangePage = (event:any, newPage:any) => {
      setPage(newPage);
    };


    const handleChangeRowsPerPage = (event:any) => {
      setPage(0);
      setRowsPerPage(parseInt(event.target.value, 10));
    };

    const handleFilterByName = (event:any) => {
      setPage(0);
      setFilterName(event.target.value);
    };

    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - projectInfo?.length) : 0;

    const filteredUsers = applySortFilter(projectInfo, getComparator(order, orderBy), filterName);

    const isNotFound = !filteredUsers.length && !!filterName;

    return (
      <>
        <Helmet>
          <title> Knowledge AI </title>
        </Helmet>

        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between"  mt={3}>
            <Typography variant="h4" gutterBottom
            sx={{
              color: theme.palette.mode === 'dark' ? '#C7C9C7' : '#333f48',
            }}>
              Projects
            </Typography>
            <Link  
             to='/dashboard/create-project'
            >
              <Button variant="contained"  className="primary-btn" startIcon={<Iconify icon="eva:plus-fill" />}>
                New Project
              </Button>
            </Link>
          </Stack>

          <Card>
            <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={projectInfo?.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                      const { ID, ProjectName, IndexName, status, BUDGET, Username, SourcePage, DEPARTMENT } = row;
                      const selectedUser = selected.indexOf(ProjectName) !== -1;

                      return (
                        <TableRow hover key={ID} tabIndex={-1} mgrname="checkbox" selected={selectedUser} disabled>
                          <TableCell padding="checkbox">
                            <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, ProjectName)} disabled/>
                          </TableCell>

                          <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              
                              <Typography variant="subtitle2" noWrap>
                                {ProjectName}
                              </Typography>
                            </Stack>
                          </TableCell>

                          <TableCell align="left" className='font-medium'>{IndexName}</TableCell>

                          <TableCell align="left" className='font-medium'>{Username}</TableCell>

                          <TableCell align="left" className='font-medium'>{`$${BUDGET}`}</TableCell>

                          <TableCell align="left">
                            <Label color={(status === 'deprecated' && 'error') || 'success'}>{sentenceCase(status)}</Label>
                          </TableCell>

                          <TableCell align="right" disabled>
                            <IconButton size="large" color="inherit" onClick={handleOpenMenu} disabled>
                              <Iconify icon={'eva:more-vertical-fill'} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>

                            <Typography variant="body2">
                              No results found for &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                              <br /> Try checking for typos or using complete words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={projectInfo?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>

        <Popover
          open={Boolean(open)}
          anchorEl={open}
          onClose={handleCloseMenu}
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              p: 1,
              width: 140,
              '& .MuiMenuItem-root': {
                px: 1,
                typography: 'body2',
                borderRadius: 0.75,
              },
            },
          }}
        >
          <MenuItem>
            <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
            Edit
          </MenuItem>

          <MenuItem sx={{ color: 'error.main' }}>
            <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
            Delete
          </MenuItem>
        </Popover>
      </>
    );
  }

export default ProjectPage;